export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || "2024-12-01";

export const dev = process.env.NODE_ENV === "development";
export const BLOG_DIR = "blog";

export const sanityDatasetStage =
  process.env.NEXT_PUBLIC_SANITY_DATASET_STAGE || "production";
export const sanityDataset = `blog-${sanityDatasetStage}`;
export const sanityDotComDataset = sanityDatasetStage;
export const sanityProjectId = "rd0y3pad";
